import { CurrencyTypeEntity } from '../entities/currency-type-entity';

export default class State {
  loaded = false;

  items: Array<CurrencyTypeEntity> = [];
}
